import gql from 'graphql-tag';

export const ATTACH_FILE = gql`
  mutation attachFile($id: Int!, $assetId: String!) {
    directory {
      attachFile(id: $id, assetId: $assetId)
    }
  }
`;
